/**
 * Support / content reporting contact.
 * All content flags and inquiries go through the website and are sent to this address.
 */
export const SUPPORT_EMAIL = 'support@alchemyelectronics.com'

/** Shown next to Alchemy emails and the support address. */
export const EMAIL_SPAM_NOTE = 'Check for spam. Emails from Alchemy often go to spam or junk.'
